import InputCus from "../../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ProductCreateColor,
  ProductFilterColor,
  ProductUpdateColor,
} from "../../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../../Component/InputCus/Select/Select";

function ColorAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const [productColor, setProductColor] = useState([]);

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      const ProductFilterColorData = await ProductFilterColor({});
      if (
        ProductFilterColorData.status &&
        ProductFilterColorData.status === 200
      ) {
        setProductColor(ProductFilterColorData.data.data.data);
      }
      if (id) {
        const FilterColorDataData = await ProductFilterColor({
          id: id,
        });
        if (FilterColorDataData.status && FilterColorDataData.status === 200) {
          setForm(FilterColorDataData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UpdateColorData = await ProductUpdateColor(form);
          if (UpdateColorData.status && UpdateColorData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Products/Color");
          }
        } else {
          const CreateColorData = await ProductCreateColor(form);
          if (CreateColorData.status && CreateColorData.status === 200) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Products/Color");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-column w-100">
              <InputCus
                type="text"
                name="name"
                id="name"
                className="m-2"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="code"
                id="code"
                className="m-2"
                text="کد"
                value={form.code || ""}
                onChange={handleChangeSearch}
              />
              <Select
                className="m-2"
                type="number"
                name="parentId"
                id="parentId"
                text="پدر"
                value={form.parentId || ""}
                onChange={handleChangeSearch}
                option={productColor.map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name,
                  };
                  return data;
                })}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ColorAE;
